import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {AbstractAdvTechService} from "../../../../shared/services/advtech/abstract-advtech.service";
import {HttpHeaders} from "@angular/common/http";

/**
 * The image upload service for individual images
 * @extends {AbstractAdvTechService}
 * @class
 */
@Injectable()
export class ImageUploadService extends AbstractAdvTechService {

  /**
   * Prefix for route
   * @protected
   * @type {string}
   */
  protected prefix: string = 'content/image';

  /**
   * Send the image to Prism
   * @returns {Observable<any>}
   * @param {FormData} formData Image form data
   */
  sendImage(formData): Observable<any> {
    this.params = formData;
    this.setLoadingMessage('Uploading image...');
    return this.callPostEndpoint('image');
  }

  /**
   * Gets the POST headers
   * @returns {HttpHeaders}
   * @protected
   */
  protected getPostHeaders(): HttpHeaders {
    return new HttpHeaders({
      'X-Requested-With': 'XMLHttpRequest',
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/content/shared/services/image-upload/image-upload-service.ts